(function (lib, img, cjs, ss, an) {

var p; // shortcut to reference prototypes

lib.ssMetadata = [];


// symbols:



(lib.Bathroom_BG_2 = function() {
	this.initialize(img.Bathroom_BG_2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2048,1508);


(lib.Bathroom_BG_3 = function() {
	this.initialize(img.Bathroom_BG_3);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1770,984);


(lib.Bathroom_BG_4 = function() {
	this.initialize(img.Bathroom_BG_4);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1800,1048);


(lib.Bathroom_BG_5 = function() {
	this.initialize(img.Bathroom_BG_5);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2828,1541);


(lib.Bathroom_BG_6 = function() {
	this.initialize(img.Bathroom_BG_6);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1320,780);


(lib.BathroomEntrance = function() {
	this.initialize(img.BathroomEntrance);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1320,780);


(lib.hairdryerpoleforearm = function() {
	this.initialize(img.hairdryerpoleforearm);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,713,589);


(lib.hairdryerupperpole = function() {
	this.initialize(img.hairdryerupperpole);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,28,387);


(lib.Joint = function() {
	this.initialize(img.Joint);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,88,88);


(lib.M_Wash_Bubble = function() {
	this.initialize(img.M_Wash_Bubble);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,208,208);


(lib.M_Wash_Bubble_pop = function() {
	this.initialize(img.M_Wash_Bubble_pop);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,176,176);


(lib.Pole = function() {
	this.initialize(img.Pole);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,28,221);


(lib.SpongeBottom = function() {
	this.initialize(img.SpongeBottom);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,189,212);


(lib.SpongeBottom_2 = function() {
	this.initialize(img.SpongeBottom_2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,170,206);


(lib.spongeshadow = function() {
	this.initialize(img.spongeshadow);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,187,176);


(lib.spongeshadow_2 = function() {
	this.initialize(img.spongeshadow_2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,174,175);


(lib.SpongeTop = function() {
	this.initialize(img.SpongeTop);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,182,206);


(lib.SpongeTop_2 = function() {
	this.initialize(img.SpongeTop_2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,255,189);


(lib.Towel_001 = function() {
	this.initialize(img.Towel_001);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,165,135);


(lib.Towel_002 = function() {
	this.initialize(img.Towel_002);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,259,243);


(lib.Towel_003 = function() {
	this.initialize(img.Towel_003);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,251,255);


(lib.Towel_004 = function() {
	this.initialize(img.Towel_004);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,261,255);


(lib.Towel_005 = function() {
	this.initialize(img.Towel_005);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,280,255);


(lib.Towel_007 = function() {
	this.initialize(img.Towel_007);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,430,141);// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.TowelUpperPole = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.hairdryerupperpole();
	this.instance.parent = this;
	this.instance.setTransform(-4.4,-13.1);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.TowelUpperPole, new cjs.Rectangle(-4.4,-13.1,28,390.5), null);


(lib.Towel_007_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.Towel_007();
	this.instance.parent = this;
	this.instance.setTransform(150,-37,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Towel_007_1, new cjs.Rectangle(150,-37.6,215.4,71.2), null);


(lib.Towel_005_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.Towel_005();
	this.instance.parent = this;
	this.instance.setTransform(134,-71,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Towel_005_1, new cjs.Rectangle(133.9,-71,140.2,127.9), null);


(lib.Towel_004_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.Towel_004();
	this.instance.parent = this;
	this.instance.setTransform(166,-53,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Towel_004_1, new cjs.Rectangle(166,-53,130.9,127.5), null);


(lib.Towel_003_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.Towel_003();
	this.instance.parent = this;
	this.instance.setTransform(165,-93,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Towel_003_1, new cjs.Rectangle(164.6,-93.4,125.9,128), null);


(lib.Towel_002_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.Towel_002();
	this.instance.parent = this;
	this.instance.setTransform(157,-59,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Towel_002_1, new cjs.Rectangle(157,-59.2,129.6,121.8), null);


(lib.Towel_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.Towel_001();
	this.instance.parent = this;
	this.instance.setTransform(176.2,-29.4);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Towel_001_1, new cjs.Rectangle(176.2,-29.4,165,135), null);


(lib.SpongeTop_2_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.SpongeTop_2();
	this.instance.parent = this;
	this.instance.setTransform(5.3,-0.2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.SpongeTop_2_1, new cjs.Rectangle(5.1,-0.2,127.7,94.6), null);


(lib.SpongeTop_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.SpongeTop();
	this.instance.parent = this;
	this.instance.setTransform(-2,0,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.SpongeTop_1, new cjs.Rectangle(-2.1,0,91.1,103), null);


(lib.spongeshadow_2_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.spongeshadow_2();
	this.instance.parent = this;
	this.instance.setTransform(2.5,0.3,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.spongeshadow_2_1, new cjs.Rectangle(2.5,0,87.2,87.8), null);


(lib.spongeshadow_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.spongeshadow();
	this.instance.parent = this;
	this.instance.setTransform(-0.2,0.1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.spongeshadow_1, new cjs.Rectangle(-0.2,0,93.7,88.1), null);


(lib.SpongeBottom_2_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.SpongeBottom_2();
	this.instance.parent = this;
	this.instance.setTransform(1.5,0,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.SpongeBottom_2_1, new cjs.Rectangle(1.5,0,85.1,103), null);


(lib.SpongeBottom_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.SpongeBottom();
	this.instance.parent = this;
	this.instance.setTransform(-4.7,2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.SpongeBottom_1, new cjs.Rectangle(-4.8,2,94.7,106), null);


(lib.SkipButton = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AADASQAAgDgCgCIgBgCIgDgBQgBAAAAAAQgBAAAAAAQgBAAAAAAQgBAAAAAAIgBABIhZBBIADiXIBVBLQADACADAAIACAAIAAABIAAgBIABgCQADgBAAgDIAChHIBdBRIgGAEIAAABIgDABIhXBAg");
	this.shape.setTransform(23.8,21.9);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#0B7E53").s().p("AgIBjIgCgBIgCgCQgCgCgBgDIACg6IhZBBQgDABgCAAIgDgBIgCgCQgCgCgBgDIAFi2QAAgDACgCQAAAAABgBQAAAAABAAQAAgBABAAQABAAAAAAQADAAADACIBWBMIAChHQAAgDACgCQAAAAABgBQAAAAABAAQAAgBABAAQABAAABAAQACAAACACIBwBiIACACIABADIgBABIAAADIgCADIgNAIIgCACIgBABIhjBJIgEABIgCAAgAgFAKIAEACIABABQABACAAADIgBA6IBYg/IACgBIAAgCIAHgDIhehRIgCBHQAAADgBABIgCABIAAABIgDAAQgCAAgDgCIhWhLIgDCWIBahAIAAgBIADgBIABAAg");
	this.shape_1.setTransform(23.9,21.8);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#0B7E53").s().p("AidCfQhChCAAhdQAAhbBChCQBChCBbAAQBdAABCBCQBBBCAABbQAABdhBBCQhCBBhdAAQhbAAhChBgAiPiPQg8A8AABTQAABUA8A8QA8A8BTAAQBUAAA8g8QA8g8AAhUQAAhTg8g8Qg8g8hUAAQhTAAg8A8g");
	this.shape_2.setTransform(22.4,22.4);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("AiPCQQg8g8AAhUQAAhTA8g8QA8g8BTAAQBUAAA8A8QA8A8AABTQAABUg8A8Qg8A8hUAAQhTAAg8g8gAiDiDQg3A2AABNQAABOA3A2QA2A3BNAAQBOAAA2g3QA3g2AAhOQAAhNg3g2Qg2g3hOAAQhNAAg2A3g");
	this.shape_3.setTransform(22.4,22.4);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#10AD70").s().p("AiDCEQg3g2AAhOQAAhNA3g2QA2g3BNAAQBOAAA2A3QA3A2AABNQAABOg3A2Qg2A3hOAAQhNAAg2g3g");
	this.shape_4.setTransform(22.4,22.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.SkipButton, new cjs.Rectangle(0,0,44.8,44.8), null);


(lib.Pole_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.Pole();
	this.instance.parent = this;
	this.instance.setTransform(-6.3,-11.7);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Pole_1, new cjs.Rectangle(-6.3,-11.7,28,221), null);


(lib.M_Wash_Bubble_pop_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble_pop();
	this.instance.parent = this;
	this.instance.setTransform(-9,-10,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_pop_1, new cjs.Rectangle(-9,-10,44,44), null);


(lib.M_Wash_Bubble_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble();
	this.instance.parent = this;
	this.instance.setTransform(-13,-13,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_1, new cjs.Rectangle(-13,-13,52,52), null);


(lib.Joint_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Joint.png
	this.instance = new lib.Joint();
	this.instance.parent = this;
	this.instance.setTransform(-4.1,-3.1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Joint_1, new cjs.Rectangle(-4.1,-3.1,44,44), null);


(lib.hairdryerupperpole_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.hairdryerupperpole();
	this.instance.parent = this;
	this.instance.setTransform(-4.9,-13.1);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.hairdryerupperpole_1, new cjs.Rectangle(-4.9,-13.1,28,387), null);


(lib.hairdryerpoleforearm_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.hairdryerpoleforearm();
	this.instance.parent = this;
	this.instance.setTransform(-17,-109,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.hairdryerpoleforearm_1, new cjs.Rectangle(-26.3,-116.6,365.9,303.4), null);


(lib.Background = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{entrance:0,small:1,medium:2,medium2:3,large:4,closeup:5});

	// Background_pngs
	this.instance = new lib.BathroomEntrance();
	this.instance.parent = this;
	this.instance.setTransform(498,344);

	this.instance_1 = new lib.Bathroom_BG_2();
	this.instance_1.parent = this;
	this.instance_1.setTransform(505,-11,0.755,0.755);

	this.instance_2 = new lib.Bathroom_BG_3();
	this.instance_2.parent = this;
	this.instance_2.setTransform(323,103,1.003,1.003);

	this.instance_3 = new lib.Bathroom_BG_4();
	this.instance_3.parent = this;
	this.instance_3.setTransform(310,89,1.003,1.003);

	this.instance_4 = new lib.Bathroom_BG_5();
	this.instance_4.parent = this;
	this.instance_4.setTransform(414,330,0.5,0.5);

	this.instance_5 = new lib.Bathroom_BG_6();
	this.instance_5.parent = this;
	this.instance_5.setTransform(182,169,1.48,1.45);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).wait(1));

	// white_fill
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("EhoZA+hMAAAh9BMDQzAAAMAAAB9Bg");
	this.shape.setTransform(1156.8,725);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(488.7,324.9,1336.4,800.2);


(lib.SmallStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("Ag1BSQgGgDAFgaIAHgaIgVgVQgVgUADgFQACgFAbgFIAbgFIAMgYQAOgYAEAAQAHAAAYAyIAbADQAbAEACAGQAEAJgtAlQAPAzgHAEQgHAEgvgaQgkAXgNAAIgEgBg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-8.7,-8.3,17.6,16.7);


(lib.LargeStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("AhGBuQgJgFAHgjIAJgiIgcgbQgbgcADgGQADgHAkgHIAjgGIARggQATghAFABQAKgBAgBDIAjAEQAkAGADAIQAFAMg7AxQAUBEgKAGQgKAFg+gjQgwAegRAAIgFAAg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.6,-11,23.4,22.1);


(lib.Tween8 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.SpongeTop_2_1();
	this.instance.parent = this;
	this.instance.setTransform(0.9,-2.4,0.5,0.5,0,0,0,68.8,47.2);

	this.instance_1 = new lib.spongeshadow_2_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-10.9,3.9,0.5,0.5,0,0,0,46.3,43.9);

	this.instance_2 = new lib.SpongeBottom_2_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-11.1,0.4,0.5,0.5,0,0,0,44.1,51.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-32.8,-26.1,65.7,52.4);


(lib.Tween7 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.SpongeTop_2_1();
	this.instance.parent = this;
	this.instance.setTransform(0.9,-2.5,0.5,0.5,0,0,0,68.8,47.2);

	this.instance_1 = new lib.spongeshadow_2_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-10.9,3.9,0.5,0.5,0,0,0,46.3,43.9);

	this.instance_2 = new lib.SpongeBottom_2_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-11.1,0.4,0.5,0.5,0,0,0,44.1,51.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-32.8,-26.2,65.7,52.4);


(lib.Tween6 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.SpongeTop_2_1();
	this.instance.parent = this;
	this.instance.setTransform(0.8,-2.5,0.5,0.5,0,0,0,68.8,47.2);

	this.instance_1 = new lib.spongeshadow_2_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-10.9,3.9,0.5,0.5,0,0,0,46.3,43.9);

	this.instance_2 = new lib.SpongeBottom_2_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-11.2,0.4,0.5,0.5,0,0,0,44.1,51.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-32.8,-26.2,65.7,52.4);


(lib.Tween5 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.SpongeTop_2_1();
	this.instance.parent = this;
	this.instance.setTransform(0.9,-2.4,0.5,0.5,0,0,0,68.8,47.2);

	this.instance_1 = new lib.spongeshadow_2_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-10.9,3.9,0.5,0.5,0,0,0,46.3,43.9);

	this.instance_2 = new lib.SpongeBottom_2_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-11.1,0.4,0.5,0.5,0,0,0,44.1,51.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-32.8,-26.1,65.7,52.4);


(lib.Tween4 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.SpongeTop_2_1();
	this.instance.parent = this;
	this.instance.setTransform(0.8,-2.4,0.5,0.5,0,0,0,68.8,47.2);

	this.instance_1 = new lib.spongeshadow_2_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-10.9,3.9,0.5,0.5,0,0,0,46.3,43.9);

	this.instance_2 = new lib.SpongeBottom_2_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-11.2,0.4,0.5,0.5,0,0,0,44.1,51.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-32.8,-26.1,65.7,52.4);


(lib.Tween3 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.SpongeTop_2_1();
	this.instance.parent = this;
	this.instance.setTransform(0.9,-2.5,0.5,0.5,0,0,0,68.8,47.2);

	this.instance_1 = new lib.spongeshadow_2_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-10.9,3.9,0.5,0.5,0,0,0,46.3,43.9);

	this.instance_2 = new lib.SpongeBottom_2_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-11.1,0.4,0.5,0.5,0,0,0,44.1,51.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-32.8,-26.2,65.7,52.4);


(lib.Tween2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.SpongeTop_2_1();
	this.instance.parent = this;
	this.instance.setTransform(0.8,-2.5,0.5,0.5,0,0,0,68.8,47.2);

	this.instance_1 = new lib.spongeshadow_2_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-10.9,3.9,0.5,0.5,0,0,0,46.3,43.9);

	this.instance_2 = new lib.SpongeBottom_2_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-11.2,0.4,0.5,0.5,0,0,0,44.1,51.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-32.8,-26.2,65.7,52.4);


(lib.Tween1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.SpongeTop_2_1();
	this.instance.parent = this;
	this.instance.setTransform(0.9,-2.4,0.5,0.5,0,0,0,68.8,47.2);

	this.instance_1 = new lib.spongeshadow_2_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-10.9,3.9,0.5,0.5,0,0,0,46.3,43.9);

	this.instance_2 = new lib.SpongeBottom_2_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-11.1,0.4,0.5,0.5,0,0,0,44.1,51.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-32.8,-26.1,65.7,52.4);


(lib.towellowerpole = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.Joint_1();
	this.instance.parent = this;
	this.instance.setTransform(304.2,136,1.578,1.578,0,0,180,14,14.1);

	this.instance_1 = new lib.Pole_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(161.3,78.1,1.578,1.578,0,-67.2,112.8,6.8,97.5);

	this.instance_2 = new lib.Joint_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(16.9,15.9,1.578,1.578,0,0,180,14.1,14.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.towellowerpole, new cjs.Rectangle(-23.8,-11.3,356.6,189.5), null);


(lib.towel_arm = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{dry:0,dry_stop:143});

	// pole segment_001
	this.instance = new lib.towellowerpole();
	this.instance.parent = this;
	this.instance.setTransform(214.3,-377.1,1,1,9.7,0,0,303.4,134.8);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({regX:154.4,regY:83.4,x:76,y:-439.3},0).wait(1).to({x:75.8,y:-423.8},0).wait(1).to({x:75.6,y:-406.3},0).wait(1).to({x:75.4,y:-386.8},0).wait(1).to({x:75.1,y:-365.2},0).wait(1).to({x:74.9,y:-341.6},0).wait(1).to({x:74.6,y:-316},0).wait(1).to({x:74.3,y:-288.3},0).wait(1).to({x:74,y:-258.6},0).wait(1).to({x:73.6,y:-226.9},0).wait(1).to({x:73.2,y:-193.2},0).wait(1).to({x:72.8,y:-157.5},0).wait(1).to({x:72.4,y:-119.7},0).wait(1).to({x:72,y:-79.8},0).wait(1).to({regX:305.1,regY:134.8,x:209.7,y:37.7},0).to({regX:305.2,regY:135.3,y:52.6},4).to({regX:305.1,regY:134.8,y:37.7},6).wait(1).to({regX:154.4,regY:83.4,rotation:8.9,x:68.7,y:-36.2},0).wait(1).to({rotation:7.6,x:67.1,y:-33},0).wait(1).to({rotation:5.8,x:65,y:-28.6},0).wait(1).to({rotation:3.6,x:62.5,y:-22.9},0).wait(1).to({rotation:0.9,x:59.8,y:-15.9},0).wait(1).to({rotation:-2.2,x:57,y:-7.5},0).wait(1).to({rotation:-5.9,x:54.5,y:2.3},0).wait(1).to({rotation:-10,x:52.2,y:13.5},0).wait(1).to({rotation:-14.5,x:50.8,y:26.2},0).wait(1).to({regX:304.9,regY:135.2,rotation:-19.5,x:209.4,y:38.1},0).wait(2).to({regY:135,rotation:-26,y:37.9},0).to({regY:135.2,rotation:-19.5,y:38.1},6).wait(20).to({rotation:-18.3,y:38.2},0).wait(2).to({regX:305.2,regY:135.6,rotation:-13.3,x:201.6,y:34.4},0).wait(2).to({regX:305,regY:135.2,rotation:-12.3,x:201.3,y:34},0).to({regX:304.9,rotation:-25.8,x:210.6,y:38.1},6).to({regX:305.4,regY:135.4,rotation:-13.6,x:207.3,y:34.3},6).wait(2).to({regX:304.7,rotation:-25.8,x:209.3,y:38.4},6).wait(6).to({regX:305.2,regY:135.6,rotation:-13.3,x:201.6,y:34.4},4).wait(2).to({regX:304.7,regY:135.4,rotation:-25.8,x:209.3,y:38.4},6).to({regX:304.8,regY:135.3,x:204.1,y:38.2},6).to({regX:304.7,regY:135.4,x:209.3,y:38.4},4).wait(12).to({regX:304.8,regY:135.2,x:167.6,y:38.2},6).to({regX:304.9,scaleX:1,scaleY:1,rotation:-18.8,x:637.2,y:-27.3},5).to({regX:305,scaleX:1,scaleY:1,rotation:-14.6,x:918.8,y:-66.7},3).to({_off:true},2).wait(251));

	// Layer 2
	this.instance_1 = new lib.TowelUpperPole();
	this.instance_1.parent = this;
	this.instance_1.setTransform(359.4,-653.1,1.578,1.578,0,-153.3,26.7,6.2,198.6);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1).to({regX:10.3,regY:181.1,x:352.5,y:-612.1},0).wait(1).to({x:352.3,y:-596.6},0).wait(1).to({x:352,y:-579.1},0).wait(1).to({x:351.7,y:-559.6},0).wait(1).to({x:351.3,y:-538},0).wait(1).to({x:351,y:-514.4},0).wait(1).to({x:350.6,y:-488.8},0).wait(1).to({x:350.2,y:-461.1},0).wait(1).to({x:349.7,y:-431.5},0).wait(1).to({x:349.2,y:-399.8},0).wait(1).to({x:348.7,y:-366},0).wait(1).to({x:348.1,y:-330.3},0).wait(1).to({x:347.6,y:-292.5},0).wait(1).to({x:346.9,y:-252.7},0).wait(1).to({regX:6.2,regY:198.4,x:352.9,y:-238.4},0).to({y:-224},4).to({y:-238.4},6).wait(40).to({regX:6.1,regY:198.3,skewX:-150.8,skewY:29.2,x:352.7,y:-238.3},0).to({regX:6.2,regY:198.4,skewX:-153.3,skewY:26.7,x:352.9,y:-238.4},8).to({regX:6,regY:198.5,skewX:-152,skewY:28,x:352.8,y:-238.6},6).to({regX:6.2,regY:198.4,skewX:-153.3,skewY:26.7,x:352.9,y:-238.4},8).wait(6).to({regX:6.1,regY:198.5,skewX:-151.3,skewY:28.7,y:-238.6},4).wait(2).to({regX:6.2,regY:198.4,skewX:-153.3,skewY:26.7,y:-238.4},6).to({regX:6.3,regY:198.1,skewX:-152.4,skewY:27.6,x:352.8,y:-237.9},6).to({regX:6.2,regY:198.4,skewX:-153.3,skewY:26.7,x:352.9,y:-238.4},4).wait(12).to({skewX:-146.4,skewY:33.6},6).to({regY:198.5,skewX:-204.8,skewY:-24.8,x:773.8,y:-380.4},8).to({_off:true},2).wait(251));

	// Towel_001
	this.instance_2 = new lib.Towel_001_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-45.1,-559.7,1,1,61.9,0,0,198.4,-3);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",-1,-1,7);

	this.instance_3 = new lib.Towel_002_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-101.8,2.5,1,1,21,0,0,215.3,-42.6);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",-1,-1,7);
	this.instance_3._off = true;

	this.instance_4 = new lib.Towel_003_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-95.4,-3.8,1,1,0,0,0,268.2,-1.4);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",-1,-1,7);

	this.instance_5 = new lib.Towel_004_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-104.3,16.7,1,1,-139.5,0,0,190.7,-17.6);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",-1,-1,7);
	this.instance_5._off = true;

	this.instance_6 = new lib.Towel_005_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-124.7,54.9,1,1,163.5,0,0,253.8,-22.8);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",-1,-1,7);

	this.instance_7 = new lib.Towel_007_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(339.1,-46.8,1.43,0.973,0,-46,-25.8,349.2,11.8);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",-1,-1,7);
	this.instance_7._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2}]}).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_2}]},4).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_2}]},6).to({state:[{t:this.instance_3}]},20).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_4}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_6,p:{regX:253.8,regY:-22.8,x:-124.7,y:54.9}}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_4}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_6,p:{regX:255.2,regY:-23.8,x:-125.8,y:47.3}}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_4}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_6,p:{regX:255.2,regY:-23.8,x:-125.8,y:47.3}}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_2}]},14).to({state:[{t:this.instance_2}]},4).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_7}]},1).to({state:[]},2).to({state:[]},13).wait(238));
	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1).to({regX:257.9,regY:37.4,rotation:61.7,x:-52.8,y:-474.7},0).wait(1).to({rotation:61.4,x:-52.7,y:-459.2},0).wait(1).to({rotation:61.1,y:-441.7},0).wait(1).to({rotation:60.7,y:-422.1},0).wait(1).to({rotation:60.3,y:-400.5},0).wait(1).to({rotation:59.9,y:-376.9},0).wait(1).to({rotation:59.4,y:-351.3},0).wait(1).to({rotation:58.9,y:-323.6},0).wait(1).to({rotation:58.3,y:-293.9},0).wait(1).to({rotation:57.7,y:-262.2},0).wait(1).to({rotation:57.1,y:-228.5},0).wait(1).to({rotation:56.4,y:-192.8},0).wait(1).to({rotation:55.7,y:-155},0).wait(1).to({rotation:55,y:-115.2},0).wait(1).to({regX:198.3,regY:-3,rotation:54.2,x:-54.7,y:-145.3},0).to({regY:-2.7,x:-55,y:-135.6},2).wait(2).to({regX:198.1,regY:-3,scaleX:1.06,scaleY:0.87,rotation:0,skewX:54,skewY:65.5,x:-51.5,y:-129.7},0).to({regX:198.3,regY:-2.6,scaleX:1,scaleY:1,rotation:59.5,skewX:0,skewY:0,x:-51.8,y:-140.3},4).wait(2).to({regY:-2.8,x:-53.3,y:-145.2},0).wait(1).to({regX:257.9,regY:37.4,rotation:59,x:-59.6,y:-68.1},0).wait(1).to({rotation:58.4,x:-62.3,y:-61},0).wait(1).to({scaleX:1,scaleY:1,rotation:57.7,x:-65.7,y:-52.4},0).wait(1).to({rotation:56.8,x:-69.8,y:-41.9},0).wait(1).to({rotation:55.8,x:-74.4,y:-29.9},0).wait(1).to({regX:198.3,regY:-2.8,scaleX:1,scaleY:1,rotation:54.7,x:-81.4,y:-88},0).to({scaleX:1,scaleY:1,rotation:51.9,x:-92.1,y:-49.1},2).to({scaleX:1,scaleY:1,rotation:55.1,x:-102.8,y:2.4},2).to({regY:-2.6,scaleX:0.91,scaleY:1.09,rotation:0,skewX:58.1,skewY:51.2,x:-101.3,y:39.6},2).to({regX:198,scaleX:1,scaleY:1,rotation:55.1,skewX:0,skewY:0,x:-103.1,y:4.1},6).to({_off:true},20).wait(52).to({_off:false,regX:198.2,regY:-2.7,scaleX:1,scaleY:1,rotation:54.9,x:-102.3,y:33.4},0).wait(14).to({rotation:32.5,x:-126,y:35},0).to({regX:198.5,regY:-2.6,scaleY:1.04,rotation:0,skewX:-9.7,skewY:6.7,x:-160.4,y:41.5},4).wait(1).to({skewX:74.7,skewY:91.2,x:-48.5,y:16.6},0).wait(1).to({regX:198.2,regY:-2.7,scaleX:1.15,scaleY:1.11,skewX:113.8,skewY:139.5,x:60.3,y:8.3},0).to({regY:-2.6,scaleX:1.4,scaleY:1.24,skewX:113.9,skewY:150.2,x:248.5,y:-28.4},2).to({_off:true,regX:349.2,regY:11.8,scaleX:1.43,scaleY:0.97,skewX:-46,skewY:-25.8,x:339.1,y:-46.8},1).wait(256));
	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(63).to({_off:false},0).wait(2).to({regX:215.4,regY:-42.5,scaleX:0.79,scaleY:1.15,rotation:0,skewX:49.5,skewY:38,x:-97.3,y:-24.9},0).to({_off:true},2).wait(10).to({_off:false,regX:215.3,regY:-42.6,scaleX:1,scaleY:1,rotation:21,skewX:0,skewY:0,x:-101.8,y:2.5},0).wait(2).to({regY:-42.4,scaleX:0.79,scaleY:1.15,rotation:0,skewX:49.5,skewY:38,x:-95.4,y:-24.9},0).to({_off:true},2).wait(10).to({_off:false,regX:214.3,regY:-42.3,scaleX:1,scaleY:1,rotation:11,skewX:0,skewY:0,x:-106.1,y:37.5},0).wait(2).to({regX:215.8,regY:-42.6,rotation:28.7,x:-92.1,y:37.7},0).wait(2).to({regX:215.3,regY:-43,scaleY:1.2,rotation:0,skewX:26.7,skewY:30.7,x:-101.5,y:13.4},0).wait(2).to({regY:-42.4,scaleX:0.79,scaleY:1.15,skewX:49.5,skewY:38,x:-95.4,y:-24.9},0).to({_off:true},2).wait(10).to({_off:false,regX:214.3,regY:-42.3,scaleX:1,scaleY:1,rotation:11,skewX:0,skewY:0,x:-106.1,y:37.5},0).wait(2).to({regX:215.6,regY:-42.4,scaleX:0.79,scaleY:1.15,rotation:0,skewX:49.5,skewY:38,x:-102.2,y:48.3},0).wait(2).to({regX:215.8,regY:-41.6,scaleY:1.13,skewX:13.4,skewY:18.5,x:-103.4,y:45.6},0).to({_off:true},2).wait(279));
	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(69).to({_off:false},0).wait(2).to({regX:189.8,regY:-18.6,rotation:-96.3,x:-128,y:38.8},0).to({_off:true},2).wait(2).to({_off:false,regX:190.7,regY:-17.5,rotation:28.5,x:-116.6,y:22.2},0).to({_off:true},2).wait(6).to({_off:false,regX:190.8,regY:-17.4,rotation:-139.5,x:-102,y:25.5},0).wait(2).to({regX:190.9,regY:-17.6,rotation:-96.3,x:-127.1,y:40.9},0).to({_off:true},2).wait(2).to({_off:false,regX:190.8,regY:-17.5,rotation:28.5,x:-109.7,y:42.6},0).to({_off:true},2).wait(10).to({_off:false,regX:190.7,regY:-17.2,rotation:-139.5,x:-100.6,y:22.9},0).wait(2).to({regX:189.2,regY:-17.1,rotation:-96.3,x:-124.2,y:38.1},0).to({_off:true},2).wait(2).to({_off:false,regX:190.8,regY:-17.5,rotation:28.5,x:-109.7,y:42.6},0).to({_off:true},2).wait(285));
	this.timeline.addTween(cjs.Tween.get(this.instance_7).wait(137).to({_off:false},1).wait(1).to({skewY:-25.8,x:444.8,y:-78.6},0).wait(1).to({x:522.8,y:-91.9},0).wait(1).to({x:650.8,y:-130.1},0).to({_off:true},2).wait(251));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-171.4,-919.8,703.8,601);


(lib.hair_dryer_arm_targeted = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dry":0,"dry_stop":153});

	// arm
	this.instance = new lib.hairdryerpoleforearm_1();
	this.instance.parent = this;
	this.instance.setTransform(215.6,-464.8,1,1,-2,0,0,304.8,133.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({regX:161.2,regY:38.2,rotation:-1.7,x:69,y:-543.1},0).wait(1).to({rotation:-1.4,x:69.4,y:-529.7},0).wait(1).to({rotation:-1,x:69.8,y:-514.9},0).wait(1).to({rotation:-0.6,x:70.3,y:-498.7},0).wait(1).to({rotation:-0.2,x:70.8,y:-481},0).wait(1).to({rotation:0.3,x:71.3,y:-461.9},0).wait(1).to({rotation:0.8,x:71.9,y:-441.3},0).wait(1).to({rotation:1.3,x:72.5,y:-419.2},0).wait(1).to({rotation:1.9,x:73.3,y:-395.7},0).wait(1).to({rotation:2.5,x:74,y:-370.8},0).wait(1).to({rotation:3.2,x:74.9,y:-344.4},0).wait(1).to({rotation:3.9,x:75.8,y:-316.6},0).wait(1).to({rotation:4.6,x:76.7,y:-287.2},0).wait(1).to({rotation:5.3,x:77.8,y:-256.4},0).wait(1).to({rotation:6.1,x:78.9,y:-224.2},0).wait(1).to({rotation:7,x:80.1,y:-190.5},0).wait(1).to({rotation:7.8,x:81.4,y:-155.2},0).wait(1).to({rotation:8.7,x:82.7,y:-118.6},0).wait(1).to({regX:305.1,regY:134.8,rotation:9.7,x:209.7,y:37.7},0).to({regX:305.2,regY:135.3,y:52.6},4).to({regX:305.1,regY:134.8,y:37.7},6).wait(1).to({regX:161.2,regY:38.2,rotation:9,x:82.7,y:-80.2},0).wait(1).to({rotation:8.1,x:80.7,y:-78},0).wait(1).to({rotation:6.8,x:78.1,y:-75},0).wait(1).to({rotation:5.1,x:75,y:-71.3},0).wait(1).to({rotation:3.2,x:71.4,y:-66.6},0).wait(1).to({rotation:0.9,x:67.3,y:-61},0).wait(1).to({rotation:-1.7,x:62.9,y:-54.4},0).wait(1).to({rotation:-4.6,x:58.4,y:-46.7},0).wait(1).to({rotation:-7.9,x:53.8,y:-38},0).wait(1).to({rotation:-11.4,x:49.4,y:-28.1},0).wait(1).to({rotation:-15.3,x:45.2,y:-17},0).wait(1).to({regX:304.9,regY:135.2,rotation:-19.5,x:209.4,y:38.1},0).to({rotation:-37.4,x:208.5,y:38.3},4).to({regY:135.3,rotation:-26.3,x:209.4,y:37.6},6).to({regY:135.2,scaleX:1,scaleY:1,rotation:-23.5,y:37.8},8).to({regY:135.6,scaleX:1,scaleY:1,rotation:-26.8,x:185.5,y:38.4},6).wait(2).to({regY:135.5,rotation:-25.8,y:38.2},4).wait(2).to({regX:304.6,regY:135.4,rotation:-25.3,x:188.4,y:38.3},0).wait(2).to({regX:304.9,regY:135.6,rotation:-24.9,x:185.5},0).wait(2).to({regY:135.5,rotation:-25.8,y:38.2},0).wait(2).to({regX:304.6,regY:135.4,rotation:-25.3,x:188.4,y:38.3},0).wait(2).to({regX:304.9,regY:135.6,rotation:-24.9,x:185.5},0).wait(2).to({regY:135.5,rotation:-25.8,y:38.2},0).wait(2).to({regX:304.6,regY:135.4,rotation:-25.3,x:188.4,y:38.3},0).wait(2).to({regX:304.9,regY:135.6,rotation:-24.9,x:185.5},0).wait(2).to({regY:135.5,rotation:-25.8,y:38.2},0).wait(2).to({regX:304.6,regY:135.4,rotation:-25.3,x:188.4,y:38.3},0).wait(2).to({regX:304.9,regY:135.6,rotation:-24.9,x:185.5},0).wait(2).to({regY:135.5,rotation:-25.8,y:38.2},0).wait(2).to({regX:304.6,regY:135.4,rotation:-25.3,x:188.4,y:38.3},0).wait(2).to({regX:304.9,regY:135.6,rotation:-24.9,x:185.5},0).wait(2).to({regY:135.5,rotation:-25.8,y:38.2},0).wait(2).to({regX:304.6,regY:135.4,rotation:-25.3,x:188.4,y:38.3},0).wait(2).to({regX:304.9,regY:135.6,rotation:-24.9,x:185.5},0).wait(2).to({regY:135.5,rotation:-25.8,y:38.2},0).to({regY:135.4,rotation:-20.8,x:185.4,y:38.3},8).to({regX:304.8,regY:135.3,rotation:3.8,x:209.3},4).to({regX:305,rotation:38.3,x:245.1,y:53.3},8).wait(2).to({regX:304.9,rotation:45.6,x:244.8,y:159.5},4).to({regX:304.8,x:209.1,y:-592.9},12).to({_off:true},8).wait(241));

	// Layer 2
	this.instance_1 = new lib.hairdryerupperpole_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(359.3,-739.8,1.578,1.578,0,-153.3,26.7,6.2,198.5);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1).to({regX:9.8,regY:181.1,x:351.8,y:-700},0).wait(1).to({x:351.7,y:-685.8},0).wait(1).to({x:351.5,y:-670.1},0).wait(1).to({x:351.2,y:-652.9},0).wait(1).to({x:351,y:-634.2},0).wait(1).to({x:350.7,y:-613.9},0).wait(1).to({x:350.5,y:-592.1},0).wait(1).to({x:350.2,y:-568.8},0).wait(1).to({x:349.9,y:-543.9},0).wait(1).to({x:349.5,y:-517.5},0).wait(1).to({x:349.2,y:-489.6},0).wait(1).to({x:348.8,y:-460.1},0).wait(1).to({x:348.4,y:-429.2},0).wait(1).to({x:348,y:-396.7},0).wait(1).to({x:347.6,y:-362.6},0).wait(1).to({x:347.1,y:-327.1},0).wait(1).to({x:346.6,y:-290},0).wait(1).to({x:346.1,y:-251.4},0).wait(1).to({regX:6.2,regY:198.4,x:352.9,y:-238.4},0).to({y:-224},4).to({y:-238.4},6).wait(30).to({regX:6.4,regY:198.5,skewX:-149.1,skewY:30.9,x:353.2,y:-238.3},6).wait(8).to({regY:198.4,skewX:-149.6,skewY:30.4,y:-238.2},0).wait(2).to({regX:6.2,regY:198.3,skewX:-149.1,skewY:30.9,x:352.9},0).wait(2).to({regX:6.4,regY:198.5,x:353.2,y:-238.3},0).wait(2).to({regY:198.4,skewX:-149.6,skewY:30.4,y:-238.2},0).wait(2).to({regX:6.2,regY:198.3,skewX:-149.1,skewY:30.9,x:352.9},0).wait(2).to({regX:6.4,regY:198.5,x:353.2,y:-238.3},0).wait(2).to({regY:198.4,skewX:-149.6,skewY:30.4,y:-238.2},0).wait(2).to({regX:6.2,regY:198.3,skewX:-149.1,skewY:30.9,x:352.9},0).wait(2).to({regX:6.4,regY:198.5,x:353.2,y:-238.3},0).wait(2).to({regY:198.4,skewX:-149.6,skewY:30.4,y:-238.2},0).wait(2).to({regX:6.2,regY:198.3,skewX:-149.1,skewY:30.9,x:352.9},0).wait(2).to({regX:6.4,regY:198.5,x:353.2,y:-238.3},0).wait(2).to({regY:198.4,skewX:-149.6,skewY:30.4,y:-238.2},0).wait(2).to({regX:6.2,regY:198.3,skewX:-149.1,skewY:30.9,x:352.9},0).wait(2).to({regX:6.4,regY:198.5,x:353.2,y:-238.3},0).wait(2).to({regY:198.4,skewX:-149.6,skewY:30.4,y:-238.2},0).wait(2).to({regY:198.5,skewX:-149.1,skewY:30.9,y:-238.3},0).wait(10).to({regX:6.2,regY:198.4,skewX:-153.3,skewY:26.7,x:352.9,y:-238.4},4).to({regY:198.5,skewX:-160.5,skewY:19.5,x:353,y:-238.5},8).wait(2).to({regX:6.1,regY:198.6,x:352.9,y:-132.2},4).to({regY:198.4,skewX:-153.3,skewY:26.7,x:352.8,y:-868.5},12).to({_off:true},8).wait(241));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-114.6,-1006.9,646.2,605.4);


(lib.Dryers = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{off:0,off_stop:4,xl:5,l:9,m:13,s:18,crocodile:22,giraffee:27,cham:35,cham_stop:44,cheetah:45,cheetah_stop:55,condor:56,condor_stop:65,cow:66,cow_stop:75,croc:76,croc_stop:85,elephant:86,elephant_stop:95,giraffe:96,giraffe_stop:106,iguana:107,iguana_stop:116,lion:117,lion_stop:126,ostrich:127,ostrich_stop:136,penguin:137,penguin_stop:146,pig:147,pig_stop:156,polar:157,polar_stop:167,sheep:168,sheep_stop:177,sloth:178,sloth_stop:187,monkey:188,monkey_stop:197,tiger:198,tiger_stop:207,toucan:208,toucan_stop:217,walrus:218,walrus_stop:227,zebra:228,zebra_stop:237});

	// Layer 1
	this.hairdryer = new lib.towel_arm();
	this.hairdryer.name = "hairdryer";
	this.hairdryer.parent = this;
	this.hairdryer.setTransform(11.4,70.5,0.459,0.459,0,-22.4,157.6,115.7,-358.1);

	this.towel = new lib.hair_dryer_arm_targeted();
	this.towel.name = "towel";
	this.towel.parent = this;
	this.towel.setTransform(630.4,119.6,0.345,0.345,0,8.8,8,116.1,-357.5);

	this.hairdryer_1 = new lib.hair_dryer_arm_targeted();
	this.hairdryer_1.name = "hairdryer_1";
	this.hairdryer_1.parent = this;
	this.hairdryer_1.setTransform(-39.5,-38.3,0.345,0.345,0,9,-171.8,116,-357.5);

	this.towel_1 = new lib.towel_arm();
	this.towel_1.name = "towel_1";
	this.towel_1.parent = this;
	this.towel_1.setTransform(505.1,-100.4,0.512,0.512,0,0,0,115.9,-358.3);

	this.poles = new lib.towel_arm();
	this.poles.name = "poles";
	this.poles.parent = this;
	this.poles.setTransform(278.2,-25.6,0.512,0.512,-16,0,0,115.9,-358.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.towel_1,p:{x:505.1,y:-100.4,regY:-358.3,scaleX:0.512,scaleY:0.512,regX:115.9,rotation:0}},{t:this.hairdryer_1,p:{regY:-357.5,skewX:9,skewY:-171.8,x:-39.5,y:-38.3,regX:116,scaleX:0.345,scaleY:0.345}},{t:this.towel},{t:this.hairdryer}]},5).to({state:[{t:this.towel_1,p:{x:432.9,y:-23.9,regY:-358.3,scaleX:0.512,scaleY:0.512,regX:115.9,rotation:0}},{t:this.hairdryer_1,p:{regY:-352,skewX:0,skewY:179.2,x:49.7,y:23,regX:116,scaleX:0.345,scaleY:0.345}}]},4).to({state:[{t:this.towel_1,p:{x:376.8,y:-30.4,regY:-358.3,scaleX:0.512,scaleY:0.512,regX:115.9,rotation:0}},{t:this.hairdryer_1,p:{regY:-357.6,skewX:0,skewY:179.2,x:8.9,y:14.6,regX:116,scaleX:0.345,scaleY:0.345}}]},4).to({state:[{t:this.towel_1,p:{x:549.4,y:-356.6,regY:-358.2,scaleX:0.512,scaleY:0.512,regX:115.9,rotation:0}},{t:this.hairdryer_1,p:{regY:-357.4,skewX:14.5,skewY:-166.3,x:35.7,y:71.7,regX:115.9,scaleX:0.345,scaleY:0.345}}]},5).to({state:[{t:this.towel_1,p:{x:455.4,y:50.5,regY:-358.2,scaleX:0.512,scaleY:0.512,regX:115.9,rotation:0}},{t:this.hairdryer_1,p:{regY:-357.5,skewX:14.5,skewY:-166.3,x:6.1,y:85.7,regX:116.1,scaleX:0.345,scaleY:0.345}}]},4).to({state:[{t:this.towel_1,p:{x:352.3,y:-55.6,regY:-358.3,scaleX:0.512,scaleY:0.512,regX:115.9,rotation:0}},{t:this.hairdryer_1,p:{regY:-357.4,skewX:1,skewY:-179.8,x:-29,y:-23.8,regX:116.1,scaleX:0.345,scaleY:0.345}}]},5).to({state:[{t:this.towel_1,p:{x:549.4,y:-356.6,regY:-358.2,scaleX:0.512,scaleY:0.512,regX:115.9,rotation:0}},{t:this.hairdryer_1,p:{regY:-357.4,skewX:14.5,skewY:-166.3,x:55.6,y:13.6,regX:116,scaleX:0.436,scaleY:0.436}}]},8).to({state:[{t:this.towel_1,p:{x:352.3,y:-55.6,regY:-358.3,scaleX:0.512,scaleY:0.512,regX:115.9,rotation:0}},{t:this.hairdryer_1,p:{regY:-357.4,skewX:13.5,skewY:-167.3,x:9,y:-17.8,regX:116,scaleX:0.345,scaleY:0.345}}]},10).to({state:[{t:this.towel_1,p:{x:448.3,y:-41.6,regY:-358.3,scaleX:0.512,scaleY:0.512,regX:115.9,rotation:0}},{t:this.hairdryer_1,p:{regY:-357.4,skewX:1,skewY:-179.8,x:79,y:-1.7,regX:116.1,scaleX:0.345,scaleY:0.345}}]},11).to({state:[{t:this.towel_1,p:{x:352.3,y:-53.6,regY:-358.3,scaleX:0.512,scaleY:0.512,regX:115.9,rotation:0}},{t:this.hairdryer_1,p:{regY:-357.9,skewX:21.8,skewY:-159.1,x:42.9,y:-45,regX:116.8,scaleX:0.294,scaleY:0.294}}]},10).to({state:[{t:this.towel_1,p:{x:350.3,y:-7.6,regY:-358.2,scaleX:0.494,scaleY:0.494,regX:115.9,rotation:0}},{t:this.hairdryer_1,p:{regY:-357.2,skewX:26.5,skewY:-154.3,x:55,y:-1.8,regX:116.2,scaleX:0.345,scaleY:0.345}}]},10).to({state:[{t:this.towel_1,p:{x:383.3,y:-56.6,regY:-358.3,scaleX:0.512,scaleY:0.512,regX:115.9,rotation:0}},{t:this.hairdryer_1,p:{regY:-357.2,skewX:26.4,skewY:-154.4,x:56.1,y:8.3,regX:116.1,scaleX:0.237,scaleY:0.237}}]},10).to({state:[{t:this.towel_1,p:{x:284.2,y:-13.6,regY:-358.4,scaleX:0.328,scaleY:0.328,regX:115.9,rotation:0}},{t:this.hairdryer_1,p:{regY:-357.2,skewX:17.8,skewY:-163.1,x:63.8,y:2.6,regX:115.9,scaleX:0.201,scaleY:0.201}}]},10).to({state:[{t:this.poles},{t:this.hairdryer_1,p:{regY:-357.4,skewX:34.3,skewY:-146.6,x:95,y:8.3,regX:116,scaleX:0.295,scaleY:0.295}}]},11).to({state:[{t:this.towel_1,p:{x:352.3,y:-39.6,regY:-358.3,scaleX:0.512,scaleY:0.512,regX:115.9,rotation:0}},{t:this.hairdryer_1,p:{regY:-357.4,skewX:20.8,skewY:-160.1,x:33.1,y:-61.8,regX:116.2,scaleX:0.307,scaleY:0.307}}]},10).to({state:[{t:this.towel_1,p:{x:326.3,y:-49.6,regY:-358.2,scaleX:0.512,scaleY:0.512,regX:115.9,rotation:0}},{t:this.hairdryer_1,p:{regY:-357.4,skewX:1,skewY:-179.8,x:-3,y:-3.8,regX:116.1,scaleX:0.345,scaleY:0.345}}]},10).to({state:[{t:this.towel_1,p:{x:372.3,y:-45.6,regY:-358.3,scaleX:0.512,scaleY:0.512,regX:115.9,rotation:0}},{t:this.hairdryer_1,p:{regY:-357.6,skewX:1,skewY:-179.8,x:67,y:4.1,regX:116.2,scaleX:0.345,scaleY:0.345}}]},10).to({state:[{t:this.towel_1,p:{x:384.3,y:-37.6,regY:-358.2,scaleX:0.512,scaleY:0.512,regX:115.9,rotation:0}},{t:this.hairdryer_1,p:{regY:-357.2,skewX:14.2,skewY:-166.6,x:60.8,y:2.2,regX:116.7,scaleX:0.323,scaleY:0.323}}]},10).to({state:[{t:this.hairdryer_1,p:{regY:-357.2,skewX:17,skewY:-163.8,x:33,y:-11.7,regX:115.9,scaleX:0.254,scaleY:0.254}},{t:this.towel_1,p:{x:328.3,y:-37.6,regY:-358.2,scaleX:0.472,scaleY:0.472,regX:116.2,rotation:-11}}]},10).to({state:[{t:this.towel_1,p:{x:394.3,y:-37.6,regY:-358.2,scaleX:0.512,scaleY:0.512,regX:115.9,rotation:0}},{t:this.hairdryer_1,p:{regY:-357.4,skewX:8.3,skewY:-172.6,x:58.9,y:0.3,regX:116.3,scaleX:0.313,scaleY:0.313}}]},11).to({state:[{t:this.towel_1,p:{x:424.3,y:-7.6,regY:-358.3,scaleX:0.512,scaleY:0.512,regX:115.9,rotation:0}},{t:this.hairdryer_1,p:{regY:-357.4,skewX:29,skewY:-151.8,x:117,y:2.2,regX:116,scaleX:0.345,scaleY:0.345}}]},10).to({state:[{t:this.towel_1,p:{x:324.3,y:-69.5,regY:-358.4,scaleX:0.544,scaleY:0.544,regX:116.1,rotation:-10.7}},{t:this.hairdryer_1,p:{regY:-357.6,skewX:22.9,skewY:-157.9,x:117.2,y:0.2,regX:115.8,scaleX:0.363,scaleY:0.363}}]},10).to({state:[{t:this.towel_1,p:{x:354.3,y:-53.6,regY:-358.3,scaleX:0.512,scaleY:0.512,regX:115.9,rotation:0}},{t:this.hairdryer_1,p:{regY:-357.4,skewX:17.3,skewY:-163.6,x:21,y:4.2,regX:116,scaleX:0.274,scaleY:0.273}}]},10).to({state:[{t:this.towel_1,p:{x:290.2,y:-29.7,regY:-358.3,scaleX:0.512,scaleY:0.512,regX:116,rotation:-13}},{t:this.hairdryer_1,p:{regY:-357.4,skewX:32.3,skewY:-148.5,x:110,y:-8.7,regX:116,scaleX:0.345,scaleY:0.345}}]},10).to({state:[{t:this.towel_1,p:{x:326.6,y:-47.5,regY:-358,scaleX:0.512,scaleY:0.512,regX:116.6,rotation:-10}},{t:this.hairdryer_1,p:{regY:-357.7,skewX:31.7,skewY:-149.2,x:59,y:-11.8,regX:116,scaleX:0.294,scaleY:0.294}}]},10).to({state:[{t:this.towel_1,p:{x:352.3,y:-39.6,regY:-358.3,scaleX:0.512,scaleY:0.512,regX:115.9,rotation:0}},{t:this.hairdryer_1,p:{regY:-357.8,skewX:26.3,skewY:-154.6,x:43,y:-55.9,regX:116.5,scaleX:0.345,scaleY:0.345}}]},10).wait(10));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.CursorDefault = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.SpongeTop_1();
	this.instance.parent = this;
	this.instance.setTransform(-0.4,1.2,0.5,0.5,0,0,0,43.4,51.4);

	this.instance_1 = new lib.spongeshadow_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-1,9.7,0.5,0.5,0,0,0,46.7,43.9);

	this.instance_2 = new lib.SpongeBottom_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-1.2,4.7,0.5,0.5,0,0,0,42.6,55);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.CursorDefault, new cjs.Rectangle(-24.9,-24.5,47.3,56.3), null);


(lib.Bubble = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{bubble:0,bubble_stop:45});

	// M_Wash_Bubble
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(-8.9,8.9,0.303,0.303,-155.3,0,0,11,10.9);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_pop_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-8.9,8.9,0.757,0.757,-155.3,0,0,11,11);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance}]},38).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance).to({regY:11,scaleX:0.76,scaleY:0.76},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-14.5,10.9,0.313,0.313,-155.3,0,0,11.1,11.1);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_pop_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-14.4,10.9,0.757,0.757,-155.3,0,0,11,11);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2}]}).to({state:[{t:this.instance_2}]},40).to({state:[{t:this.instance_3}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76,x:-14.4},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(0.5,6.1,0.287,0.287,-155.3,0,0,10.9,10.7);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_pop_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(0.6,6.1,0.757,0.757,-155.3,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4}]}).to({state:[{t:this.instance_4}]},34).to({state:[{t:this.instance_5}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76,x:0.6},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-29.1,-12.5,0.199,0.199,-155.3,0,0,11,10.7);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_pop_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(-29.1,-12.5,0.757,0.757,-155.3,0,0,11,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_6}]}).to({state:[{t:this.instance_7}]},32).to({state:[{t:this.instance_7}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_6).to({_off:true,regY:11,scaleX:0.76,scaleY:0.76},32).wait(60));

	// M_Wash_Bubble
	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(-13.3,-11.5,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_pop_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(-13.3,-11.5,0.757,0.757,-155.3,0,0,11,11);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_8}]}).to({state:[{t:this.instance_9}]},36).to({state:[{t:this.instance_9}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_8).to({_off:true,regX:11,regY:11,scaleX:0.76,scaleY:0.76},36).wait(56));

	// M_Wash_Bubble
	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(-16.8,-4,0.108,0.108,-155.3,0,0,11,11.7);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_pop_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(-16.9,-4,0.757,0.757,-155.3,0,0,11.2,11);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_10}]}).to({state:[{t:this.instance_11}]},30).to({state:[{t:this.instance_11}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_10).to({_off:true,regX:11.2,regY:11,scaleX:0.76,scaleY:0.76,x:-16.9},30).wait(62));

	// M_Wash_Bubble
	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(-9.8,-19,0.119,0.119,-155.3,0,0,11.5,10.9);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_13 = new lib.M_Wash_Bubble_pop_1();
	this.instance_13.parent = this;
	this.instance_13.setTransform(-9.8,-19,0.757,0.757,-155.3,0,0,11,11);
	this.instance_13.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12}]}).to({state:[{t:this.instance_13}]},32).to({state:[{t:this.instance_13}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_12).to({_off:true,regX:11,regY:11,scaleX:0.76,scaleY:0.76},32).wait(60));

	// M_Wash_Bubble
	this.instance_14 = new lib.M_Wash_Bubble_1();
	this.instance_14.parent = this;
	this.instance_14.setTransform(3.2,-13.1,0.271,0.271,-155.3,0,0,10.3,11.3);
	this.instance_14.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_15 = new lib.M_Wash_Bubble_pop_1();
	this.instance_15.parent = this;
	this.instance_15.setTransform(3.3,-13.1,0.757,0.757,-155.3,0,0,10.9,11.1);
	this.instance_15.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_14}]}).to({state:[{t:this.instance_15}]},30).to({state:[{t:this.instance_15}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_14).to({_off:true,regX:10.9,regY:11.1,scaleX:0.76,scaleY:0.76,x:3.3},30).wait(62));

	// M_Wash_Bubble
	this.instance_16 = new lib.M_Wash_Bubble_1();
	this.instance_16.parent = this;
	this.instance_16.setTransform(9.3,-1,0.125,0.125,-155.3,0,0,11,10.4);
	this.instance_16.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_16).to({regY:11,scaleX:0.76,scaleY:0.76,x:9.4,y:-1.1},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_17 = new lib.M_Wash_Bubble_1();
	this.instance_17.parent = this;
	this.instance_17.setTransform(-6.4,-26.6,0.076,0.076,-155.3,0,0,10.8,11);
	this.instance_17.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_17).to({regX:11,scaleX:0.76,scaleY:0.76},20).wait(2).to({_off:true},2).wait(68));

	// M_Wash_Bubble
	this.instance_18 = new lib.M_Wash_Bubble_1();
	this.instance_18.parent = this;
	this.instance_18.setTransform(-3.5,-4.9,0.103,0.103,-155.3,0,0,10.3,10.8);
	this.instance_18.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_18).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76,x:-6.4,y:-2.3},22).wait(2).to({x:-3.5,y:-4.9},0).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_19 = new lib.M_Wash_Bubble_1();
	this.instance_19.parent = this;
	this.instance_19.setTransform(17,-9.7,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_19.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_20 = new lib.M_Wash_Bubble_pop_1();
	this.instance_20.parent = this;
	this.instance_20.setTransform(13,-14.5,0.686,0.686,-155.4,0,0,10.3,11.2);
	this.instance_20.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_19}]}).to({state:[{t:this.instance_19}]},24).to({state:[{t:this.instance_20}]},2).to({state:[]},2).wait(64));
	this.timeline.addTween(cjs.Tween.get(this.instance_19).to({regX:10.3,scaleX:0.69,scaleY:0.69,rotation:-155.4,x:13,y:-14.5},24).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_21 = new lib.M_Wash_Bubble_1();
	this.instance_21.parent = this;
	this.instance_21.setTransform(13.4,10,0.067,0.067,-155.3,0,0,11.7,11.1);
	this.instance_21.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_22 = new lib.M_Wash_Bubble_pop_1();
	this.instance_22.parent = this;
	this.instance_22.setTransform(13.4,9.8,0.757,0.757,-155.3,0,0,11.2,11.1);
	this.instance_22.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_21}]}).to({state:[{t:this.instance_21}]},22).to({state:[{t:this.instance_22}]},8).to({state:[{t:this.instance_22}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_21).to({regY:11.2,scaleX:0.53,scaleY:0.53,rotation:-155.4,x:7.9,y:11.6},22).to({_off:true,regX:11.2,regY:11.1,scaleX:0.76,scaleY:0.76,rotation:-155.3,x:13.4,y:9.8},8).wait(62));

	// M_Wash_Bubble
	this.instance_23 = new lib.M_Wash_Bubble_1();
	this.instance_23.parent = this;
	this.instance_23.setTransform(-0.5,-18.5,0.4,0.4,0,0,0,11,11);
	this.instance_23.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_24 = new lib.M_Wash_Bubble_pop_1();
	this.instance_24.parent = this;
	this.instance_24.setTransform(-0.5,-18.5,1,1,0,0,0,11,11);
	this.instance_24.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_23}]}).to({state:[{t:this.instance_23}]},38).to({state:[{t:this.instance_24}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance_23).to({scaleX:1,scaleY:1},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_25 = new lib.M_Wash_Bubble_1();
	this.instance_25.parent = this;
	this.instance_25.setTransform(5,-24,0.413,0.413,0,0,0,11,11);
	this.instance_25.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_26 = new lib.M_Wash_Bubble_pop_1();
	this.instance_26.parent = this;
	this.instance_26.setTransform(5,-24,1,1,0,0,0,11,11);
	this.instance_26.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_25}]}).to({state:[{t:this.instance_25}]},40).to({state:[{t:this.instance_26}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_25).to({scaleX:1,scaleY:1},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_27 = new lib.M_Wash_Bubble_1();
	this.instance_27.parent = this;
	this.instance_27.setTransform(-10.3,-10,0.379,0.379,0,0,0,11,11);
	this.instance_27.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_28 = new lib.M_Wash_Bubble_pop_1();
	this.instance_28.parent = this;
	this.instance_28.setTransform(-10.3,-10,1,1,0,0,0,11,11);
	this.instance_28.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_27}]}).to({state:[{t:this.instance_27}]},34).to({state:[{t:this.instance_28}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_27).to({scaleX:1,scaleY:1},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_29 = new lib.M_Wash_Bubble_1();
	this.instance_29.parent = this;
	this.instance_29.setTransform(35.5,-4,0.263,0.263,0,0,0,11,11);
	this.instance_29.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_30 = new lib.M_Wash_Bubble_pop_1();
	this.instance_30.parent = this;
	this.instance_30.setTransform(35.5,-4,1,1,0,0,0,11,11);
	this.instance_30.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_29}]}).to({state:[{t:this.instance_30}]},32).to({state:[{t:this.instance_30}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_29).to({_off:true,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_31 = new lib.M_Wash_Bubble_1();
	this.instance_31.parent = this;
	this.instance_31.setTransform(15.9,3.5,0.214,0.214,0,0,0,11,11.2);
	this.instance_31.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_32 = new lib.M_Wash_Bubble_pop_1();
	this.instance_32.parent = this;
	this.instance_32.setTransform(15.9,3.5,1,1,0,0,0,11,11);
	this.instance_32.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_31}]}).to({state:[{t:this.instance_32}]},36).to({state:[{t:this.instance_32}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_31).to({_off:true,regY:11,scaleX:1,scaleY:1},36).wait(56));

	// M_Wash_Bubble
	this.instance_33 = new lib.M_Wash_Bubble_1();
	this.instance_33.parent = this;
	this.instance_33.setTransform(16,-7.5,0.143,0.143,0,0,0,10.8,11.2);
	this.instance_33.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_34 = new lib.M_Wash_Bubble_pop_1();
	this.instance_34.parent = this;
	this.instance_34.setTransform(16,-7.5,1,1,0,0,0,11,11);
	this.instance_34.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_33}]}).to({state:[{t:this.instance_34}]},30).to({state:[{t:this.instance_34}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_33).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_35 = new lib.M_Wash_Bubble_1();
	this.instance_35.parent = this;
	this.instance_35.setTransform(15.9,14.5,0.157,0.157,0,0,0,11.2,11.2);
	this.instance_35.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_36 = new lib.M_Wash_Bubble_pop_1();
	this.instance_36.parent = this;
	this.instance_36.setTransform(15.9,14.5,1,1,0,0,0,11,11);
	this.instance_36.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_35}]}).to({state:[{t:this.instance_36}]},32).to({state:[{t:this.instance_36}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_35).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_37 = new lib.M_Wash_Bubble_1();
	this.instance_37.parent = this;
	this.instance_37.setTransform(-3,14.5,0.357,0.357,0,0,0,10.2,11.1);
	this.instance_37.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_38 = new lib.M_Wash_Bubble_pop_1();
	this.instance_38.parent = this;
	this.instance_38.setTransform(-3,14.5,1,1,0,0,0,11,11);
	this.instance_38.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_37}]}).to({state:[{t:this.instance_38}]},30).to({state:[{t:this.instance_38}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_37).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_39 = new lib.M_Wash_Bubble_1();
	this.instance_39.parent = this;
	this.instance_39.setTransform(-17,3.5,0.165,0.165,0,0,0,11,11);
	this.instance_39.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_39).to({regX:10.9,regY:10.9,scaleX:0.91,scaleY:0.91,x:-20.4,y:3.3},22).to({regX:11,regY:11,scaleX:1,scaleY:1,x:-17,y:3.5},2).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_40 = new lib.M_Wash_Bubble_1();
	this.instance_40.parent = this;
	this.instance_40.setTransform(0.7,1,0.136,0.136,0,0,0,11.1,11.1);
	this.instance_40.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_40).to({regX:11,regY:11,scaleX:1,scaleY:1},22).wait(2).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_41 = new lib.M_Wash_Bubble_1();
	this.instance_41.parent = this;
	this.instance_41.setTransform(-21.3,18,0.164,0.164,0,0,0,10.7,11);
	this.instance_41.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_41).to({regX:11,scaleX:1,scaleY:1},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_42 = new lib.M_Wash_Bubble_1();
	this.instance_42.parent = this;
	this.instance_42.setTransform(-28,-7.5,0.088,0.088,0,0,0,10.8,10.8);
	this.instance_42.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_43 = new lib.M_Wash_Bubble_pop_1();
	this.instance_43.parent = this;
	this.instance_43.setTransform(-28,-7.5,1,1,0,0,0,11,11);
	this.instance_43.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_42}]}).to({state:[{t:this.instance_43}]},30).to({state:[{t:this.instance_43}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_42).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-50.2,-47.9,114.4,93.8);


(lib.star_2_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.SmallStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,-4.2,-0.7,-6.2,-1.6,-9.1,-2.8,-9.1,-4.5,-9.1,-6.3,-6,-7.7,-4.2,-8.6,0.7,-10,5.6,-11.4,7.5,-12.3,10.6,-13.8,10.6,-15.6,10.6,-17.5,7.3,-18.9,5.3,-19.8,0.1,-21.1,-5.1,-22.4,-7,-23.2,-10.3,-24.5,-10.3,-26.3,-10.3,-28,-7.2,-29.3,-5.7,-30,-1.7,-31.1], orient:'auto'},alpha:0.102},16).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-5.1,-4.7,10.5,10);


(lib.star_1_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.LargeStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,4.5,-0.7,6.5,-1.6,9.4,-2.8,9.4,-4.5,9.4,-6.3,6.3,-7.7,4.5,-8.6,-0.4,-10,-5.3,-11.4,-7.2,-12.3,-10.3,-13.8,-10.3,-15.6,-10.3,-17.5,-7,-18.9,-5,-19.8,0.1,-21.1,5.4,-22.4,7.3,-23.2,10.6,-24.5,10.6,-26.3,10.6,-28,7.5,-29.3,6,-30,2,-31.1], orient:'auto'},alpha:0.102},13).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-6.9,-6.4,14,13.3);


(lib.sparkle2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_2_anim();
	this.innerSparkle.name = "innerSparkle";
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle2, new cjs.Rectangle(-5.2,-4.7,10.6,10), null);


(lib.sparkle1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_1_anim();
	this.innerSparkle.name = "innerSparkle";
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle1, new cjs.Rectangle(-6.9,-6.4,14,13.3), null);


(lib.BlocksSparkle = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.sparkle2();
	this.instance.parent = this;
	this.instance.setTransform(20,-29,0.365,0.365,38.2,0,0,0,0.2);

	this.instance_1 = new lib.sparkle2();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-1.9,23.9,0.365,0.365,83.2,0,0,-0.1,0.2);

	this.instance_2 = new lib.sparkle2();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-17.3,-25,0.614,0.614,83.2,0,0,-0.1,0.2);

	this.instance_3 = new lib.sparkle2();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-25.1,-3.7,0.614,0.614,-25.9);

	this.instance_4 = new lib.sparkle2();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-28.5,18.5,0.614,0.614,-10.9);

	this.instance_5 = new lib.sparkle1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(34.7,-21.2,0.614,0.614,73.9);

	this.instance_6 = new lib.sparkle1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-19,36,0.614,0.614,-152.4);

	this.instance_7 = new lib.sparkle1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(-17.1,-36,0.614,0.614,-9.3);

	this.instance_8 = new lib.sparkle1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(37.1,7.5,0.615,0.615,-15);

	this.instance_9 = new lib.sparkle2();
	this.instance_9.parent = this;
	this.instance_9.setTransform(22.4,-19.1,0.614,0.614,51.9);

	this.instance_10 = new lib.sparkle1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(-21.8,-1.6,0.614,0.614,-76.2);

	this.instance_11 = new lib.sparkle1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(11.6,21.5,0.614,0.614,152.9);

	this.instance_12 = new lib.sparkle1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(-21.7,24.9,0.614,0.614,-157.2);

	this.instance_13 = new lib.sparkle2();
	this.instance_13.parent = this;
	this.instance_13.setTransform(-2.2,-24.8,0.614,0.614,34.1);

	this.instance_14 = new lib.sparkle2();
	this.instance_14.parent = this;
	this.instance_14.setTransform(15.6,36.2,0.614,0.614,160.5,0,0,0,0.2);

	this.instance_15 = new lib.sparkle2();
	this.instance_15.parent = this;
	this.instance_15.setTransform(16.4,-34.9,0.614,0.614,14.5,0,0,0.1,0.2);

	this.instance_16 = new lib.sparkle2();
	this.instance_16.parent = this;
	this.instance_16.setTransform(34.6,-0.6,0.614,0.614,-52,0,0,0,0.1);

	this.instance_17 = new lib.sparkle2();
	this.instance_17.parent = this;
	this.instance_17.setTransform(33.6,27.5,0.614,0.614,114.3,0,0,0,0.2);

	this.instance_18 = new lib.sparkle2();
	this.instance_18.parent = this;
	this.instance_18.setTransform(-34.9,-21,0.614,0.614,-118.7,0,0,0.1,0.2);

	this.instance_19 = new lib.sparkle1();
	this.instance_19.parent = this;
	this.instance_19.setTransform(-34.3,24.8,0.614,0.614,-112.5);

	this.instance_20 = new lib.sparkle1();
	this.instance_20.parent = this;
	this.instance_20.setTransform(7.2,-15,0.614,0.614,14,0,0,0,0.2);

	this.instance_21 = new lib.sparkle2();
	this.instance_21.parent = this;
	this.instance_21.setTransform(26.7,17.4,0.614,0.614,108.3,0,0,0.1,0.2);

	this.instance_22 = new lib.sparkle2();
	this.instance_22.parent = this;
	this.instance_22.setTransform(28.9,-1.7,0.614,0.614,68.2,0,0,0,0.2);

	this.instance_23 = new lib.sparkle2();
	this.instance_23.parent = this;
	this.instance_23.setTransform(-6.6,20.8,0.614,0.614,-171,0,0,0.1,0.2);

	this.instance_24 = new lib.sparkle1();
	this.instance_24.parent = this;
	this.instance_24.setTransform(-17.4,-20.8,0.614,0.614,-52.8,0,0,0.1,0.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_24},{t:this.instance_23},{t:this.instance_22},{t:this.instance_21},{t:this.instance_20},{t:this.instance_19},{t:this.instance_18},{t:this.instance_17},{t:this.instance_16},{t:this.instance_15},{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.BlocksSparkle, new cjs.Rectangle(-39.6,-40.6,82,82), null);


(lib.StarCursor = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// star
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#D89F01").s().p("AgcCzQgVABgMg+IAAAAIgHguIgwgTIAAAAQg+gbADgQQgBgOAzghQAUgPAUgLIAEgxQAIg+ANgDIAAAAQARgKBTBKIAtgNQA7gPALAOQASAQgzBoQBDBUgQARQgLAQhqgLQg4BQgaAAIgCAAgAgbCfQATgCAzhLQACgCACgBIAGgBQBfALAJgIQAEgIg7hJQgCgCAAgDQgBgDACgCQAuhdgHgLQgHgEgrALIAAAAIgyAPIgFAAIgEgDQhJhBgKABQgDAEgGAuIgEA1IgCAEIgDAEQgWAMgWAPIAAAAQgmAYgDAIQACAEAtAUIA1AUQACABACACIACAFIAIA0IAAgBQAIAqAGADg");
	this.shape.setTransform(17,18.1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFF00").s().p("AgqBzIAAABIgIg0IgCgFQgCgDgCgBIg1gUQgtgTgCgFQADgHAmgYIAAAAQAWgQAWgMIADgDIACgFIAEg1QAGguADgDQAKgBBJBBIAEACIAFAAIAygOIAAAAQArgMAHAFQAHAKguBdQgCADABADQAAADACABQA7BJgEAJQgJAHhfgLIgGABQgCABgCADQgzBKgTACQgGgCgIgqg");
	this.shape_1.setTransform(17.1,18);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	// sparkle
	this.sparkle = new lib.BlocksSparkle();
	this.sparkle.name = "sparkle";
	this.sparkle.parent = this;
	this.sparkle.setTransform(20.9,26.8,0.904,0.832);

	this.timeline.addTween(cjs.Tween.get(this.sparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.StarCursor, new cjs.Rectangle(-14.9,-6.9,74,68.2), null);


(lib.CursorClick = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{wash:0,"wash":70,wash_stop:71,click_stop:75});

	// Layer 1
	this.instance = new lib.Tween1("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(9.8,1.6);

	this.instance_1 = new lib.Tween2("synched",0);
	this.instance_1.parent = this;
	this.instance_1.setTransform(-2.7,-14.6);
	this.instance_1._off = true;

	this.instance_2 = new lib.Tween3("synched",0);
	this.instance_2.parent = this;
	this.instance_2.setTransform(30.8,-16.3);
	this.instance_2._off = true;

	this.instance_3 = new lib.Tween4("synched",0);
	this.instance_3.parent = this;
	this.instance_3.setTransform(-4.4,13.4);
	this.instance_3._off = true;

	this.instance_4 = new lib.Tween5("synched",0);
	this.instance_4.parent = this;
	this.instance_4.setTransform(28.3,14.6);
	this.instance_4._off = true;

	this.instance_5 = new lib.Tween6("synched",0);
	this.instance_5.parent = this;
	this.instance_5.setTransform(-2.7,-14.6);
	this.instance_5._off = true;

	this.instance_6 = new lib.Tween7("synched",0);
	this.instance_6.parent = this;
	this.instance_6.setTransform(30.8,-16.3);
	this.instance_6._off = true;

	this.instance_7 = new lib.Tween8("synched",0);
	this.instance_7.parent = this;
	this.instance_7.setTransform(9.8,1.6);

	this.instance_8 = new lib.CursorDefault();
	this.instance_8.parent = this;
	this.instance_8.setTransform(-1.7,3.5,1,1,0,0,0,-1.3,3.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},10).to({state:[{t:this.instance_2}]},10).to({state:[{t:this.instance_3}]},10).to({state:[{t:this.instance_4}]},10).to({state:[{t:this.instance_5}]},10).to({state:[{t:this.instance_6}]},10).to({state:[{t:this.instance_7}]},10).to({state:[{t:this.instance_8}]},1).to({state:[{t:this.instance_7}]},4).wait(71));
	this.timeline.addTween(cjs.Tween.get(this.instance).to({_off:true,x:-2.7,y:-14.6},10).wait(136));
	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({_off:false},10).to({_off:true,x:30.8,y:-16.3},10).wait(126));
	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(10).to({_off:false},10).to({_off:true,x:-4.4,y:13.4},10).wait(116));
	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(20).to({_off:false},10).to({_off:true,x:28.3,y:14.6},10).wait(106));
	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(30).to({_off:false},10).to({_off:true,x:-2.7,y:-14.6},10).wait(96));
	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(40).to({_off:false},10).to({_off:true,x:30.8,y:-16.3},10).wait(86));
	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(50).to({_off:false},10).to({_off:true,x:9.8,y:1.6},10).wait(76));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-23,-24.5,65.7,52.4);


(lib.Cursor = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"default":0,default_stop:1,hover:2,hover_loop:6,click:7,"click_stop":17,"wash":18,"wash_stop":89});

	// sparkle
	this.instance = new lib.SpongeTop_1();
	this.instance.parent = this;
	this.instance.setTransform(-8.9,2.5,0.81,0.81,0,0,0,43.4,51.4);

	this.instance_1 = new lib.spongeshadow_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-9.8,16.2,0.81,0.81,0,0,0,46.8,43.9);

	this.instance_2 = new lib.SpongeBottom_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-10.1,8.1,0.81,0.81,0,0,0,42.6,55);

	this.instance_3 = new lib.Tween8("synched",0);
	this.instance_3.parent = this;
	this.instance_3.setTransform(7.6,3.1,1.62,1.62);

	this.instance_4 = new lib.Tween1("synched",0);
	this.instance_4.parent = this;
	this.instance_4.setTransform(7.6,3.1,1.62,1.62);
	this.instance_4._off = true;

	this.instance_5 = new lib.Tween2("synched",0);
	this.instance_5.parent = this;
	this.instance_5.setTransform(-12.5,-23,1.62,1.62);
	this.instance_5._off = true;

	this.instance_6 = new lib.Tween3("synched",0);
	this.instance_6.parent = this;
	this.instance_6.setTransform(41.6,-25.9,1.62,1.62);
	this.instance_6._off = true;

	this.instance_7 = new lib.Tween4("synched",0);
	this.instance_7.parent = this;
	this.instance_7.setTransform(-15.3,22.1,1.62,1.62);
	this.instance_7._off = true;

	this.instance_8 = new lib.Tween5("synched",0);
	this.instance_8.parent = this;
	this.instance_8.setTransform(37.6,24.2,1.62,1.62);
	this.instance_8._off = true;

	this.instance_9 = new lib.Tween6("synched",0);
	this.instance_9.parent = this;
	this.instance_9.setTransform(-12.5,-23,1.62,1.62);
	this.instance_9._off = true;

	this.instance_10 = new lib.Tween7("synched",0);
	this.instance_10.parent = this;
	this.instance_10.setTransform(41.6,-25.9,1.62,1.62);
	this.instance_10._off = true;

	this.instance_11 = new lib.CursorDefault();
	this.instance_11.parent = this;
	this.instance_11.setTransform(-11.1,6.2,1.62,1.62,0,0,0,-1.4,3.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},2).to({state:[{t:this.instance_3}]},5).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},10).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_8}]},1).to({state:[{t:this.instance_8}]},1).to({state:[{t:this.instance_8}]},1).to({state:[{t:this.instance_8}]},1).to({state:[{t:this.instance_8}]},1).to({state:[{t:this.instance_8}]},1).to({state:[{t:this.instance_8}]},1).to({state:[{t:this.instance_8}]},1).to({state:[{t:this.instance_8}]},1).to({state:[{t:this.instance_8}]},1).to({state:[{t:this.instance_9}]},1).to({state:[{t:this.instance_9}]},1).to({state:[{t:this.instance_9}]},1).to({state:[{t:this.instance_9}]},1).to({state:[{t:this.instance_9}]},1).to({state:[{t:this.instance_9}]},1).to({state:[{t:this.instance_9}]},1).to({state:[{t:this.instance_9}]},1).to({state:[{t:this.instance_9}]},1).to({state:[{t:this.instance_9}]},1).to({state:[{t:this.instance_10}]},1).to({state:[{t:this.instance_10}]},1).to({state:[{t:this.instance_10}]},1).to({state:[{t:this.instance_10}]},1).to({state:[{t:this.instance_10}]},1).to({state:[{t:this.instance_10}]},1).to({state:[{t:this.instance_10}]},1).to({state:[{t:this.instance_10}]},1).to({state:[{t:this.instance_10}]},1).to({state:[{t:this.instance_10}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_11}]},1).wait(4));
	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(18).to({_off:false},0).wait(1).to({x:5.6,y:0.5},0).wait(1).to({x:3.5,y:-2.1},0).wait(1).to({x:1.5,y:-4.6},0).wait(1).to({x:-0.4,y:-7.3},0).wait(1).to({x:-2.3,y:-9.9},0).wait(1).to({x:-4.4,y:-12.5},0).wait(1).to({x:-6.4,y:-15.2},0).wait(1).to({x:-8.4,y:-17.8},0).wait(1).to({x:-10.4,y:-20.4},0).to({_off:true},1).wait(65));
	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(28).to({_off:false},0).wait(1).to({x:-7.1,y:-23.3},0).wait(1).to({x:-1.6,y:-23.6},0).wait(1).to({x:3.7,y:-23.9},0).wait(1).to({x:9.1,y:-24.2},0).wait(1).to({x:14.6,y:-24.4},0).wait(1).to({x:19.9,y:-24.8},0).wait(1).to({x:25.3,y:-25},0).wait(1).to({x:30.8,y:-25.3},0).wait(1).to({x:36.2,y:-25.6},0).to({_off:true},1).wait(55));
	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(38).to({_off:false},0).wait(1).to({x:35.9,y:-21.1},0).wait(1).to({x:30.2,y:-16.2},0).wait(1).to({x:24.5,y:-11.4},0).wait(1).to({x:18.8,y:-6.6},0).wait(1).to({x:13.1,y:-1.8},0).wait(1).to({x:7.4,y:2.9},0).wait(1).to({x:1.7,y:7.7},0).wait(1).to({x:-3.9,y:12.5},0).wait(1).to({x:-9.6,y:17.4},0).to({_off:true},1).wait(45));
	this.timeline.addTween(cjs.Tween.get(this.instance_7).wait(48).to({_off:false},0).wait(1).to({x:-10,y:22.4},0).wait(1).to({x:-4.7,y:22.5},0).wait(1).to({x:0.5,y:22.8},0).wait(1).to({x:5.8,y:22.9},0).wait(1).to({x:11.1,y:23.2},0).wait(1).to({x:16.3,y:23.3},0).wait(1).to({x:21.7,y:23.6},0).wait(1).to({x:26.9,y:23.7},0).wait(1).to({x:32.3,y:24},0).to({_off:true},1).wait(35));
	this.timeline.addTween(cjs.Tween.get(this.instance_8).wait(58).to({_off:false},0).wait(1).to({x:32.5,y:19.5},0).wait(1).to({x:27.5,y:14.7},0).wait(1).to({x:22.5,y:10},0).wait(1).to({x:17.5,y:5.2},0).wait(1).to({x:12.5,y:0.5},0).wait(1).to({x:7.5,y:-4.1},0).wait(1).to({x:2.5,y:-8.9},0).wait(1).to({x:-2.4,y:-13.5},0).wait(1).to({x:-7.5,y:-18.3},0).to({_off:true},1).wait(25));
	this.timeline.addTween(cjs.Tween.get(this.instance_9).wait(68).to({_off:false},0).wait(1).to({x:-7.1,y:-23.3},0).wait(1).to({x:-1.6,y:-23.6},0).wait(1).to({x:3.7,y:-23.9},0).wait(1).to({x:9.1,y:-24.2},0).wait(1).to({x:14.6,y:-24.4},0).wait(1).to({x:19.9,y:-24.8},0).wait(1).to({x:25.3,y:-25},0).wait(1).to({x:30.8,y:-25.3},0).wait(1).to({x:36.2,y:-25.6},0).to({_off:true},1).wait(15));
	this.timeline.addTween(cjs.Tween.get(this.instance_10).wait(78).to({_off:false},0).wait(1).to({x:38.2,y:-23},0).wait(1).to({x:34.8,y:-20},0).wait(1).to({x:31.4,y:-17.1},0).wait(1).to({x:28,y:-14.2},0).wait(1).to({x:24.6,y:-11.3},0).wait(1).to({x:21.2,y:-8.5},0).wait(1).to({x:17.8,y:-5.5},0).wait(1).to({x:14.4,y:-2.6},0).wait(1).to({x:11,y:0.2},0).to({_off:true},1).wait(5));

	// sparkle
	this.sparkle = new lib.BlocksSparkle();
	this.sparkle.name = "sparkle";
	this.sparkle.parent = this;
	this.sparkle.setTransform(-9.6,5.2,1.464,1.348,0,0,0,0,0.1);
	this.sparkle._off = true;

	this.timeline.addTween(cjs.Tween.get(this.sparkle).wait(2).to({_off:false},0).to({_off:true},5).wait(86));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-48.5,-39.2,76.6,91.2);


// stage content:
(lib.Game = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{main:0,main_stop:46});

	// skip
	this.skipButton = new lib.SkipButton();
	this.skipButton.name = "skipButton";
	this.skipButton.parent = this;
	this.skipButton.setTransform(1128.3,162,2,2,0,0,0,22.4,22.4);

	this.timeline.addTween(cjs.Tween.get(this.skipButton).wait(47));

	// backgrounds
	this.bg = new lib.Background();
	this.bg.name = "bg";
	this.bg.parent = this;
	this.bg.setTransform(609.4,303,1,1,0,0,0,1104,633.8);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(47));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(654,384,1336.4,800.2);
// library properties:
lib.properties = {
	id: '34C4802D30D7425CB15EC705EC755935',
	width: 1320,
	height: 780,
	fps: 24,
	color: "#000000",
	opacity: 1.00,
	manifest: [
		{src:"../../../deploy/assets/images/Bathroom_BG_2.png", id:"Bathroom_BG_2"},
		{src:"../../../deploy/assets/images/Bathroom_BG_3.png", id:"Bathroom_BG_3"},
		{src:"../../../deploy/assets/images/Bathroom_BG_4.png", id:"Bathroom_BG_4"},
		{src:"../../../deploy/assets/images/Bathroom_BG_5.png", id:"Bathroom_BG_5"},
		{src:"../../../deploy/assets/images/Bathroom_BG_6.png", id:"Bathroom_BG_6"},
		{src:"../../../deploy/assets/images/BathroomEntrance.png", id:"BathroomEntrance"},
		{src:"../../../deploy/assets/images/hairdryerpoleforearm.png", id:"hairdryerpoleforearm"},
		{src:"../../../deploy/assets/images/hairdryerupperpole.png", id:"hairdryerupperpole"},
		{src:"../../../deploy/assets/images/Joint.png", id:"Joint"},
		{src:"../../../deploy/assets/images/M_Wash_Bubble.png", id:"M_Wash_Bubble"},
		{src:"../../../deploy/assets/images/M_Wash_Bubble_pop.png", id:"M_Wash_Bubble_pop"},
		{src:"../../../deploy/assets/images/Pole.png", id:"Pole"},
		{src:"../../../deploy/assets/images/SpongeBottom.png", id:"SpongeBottom"},
		{src:"../../../deploy/assets/images/SpongeBottom_2.png", id:"SpongeBottom_2"},
		{src:"../../../deploy/assets/images/spongeshadow.png", id:"spongeshadow"},
		{src:"../../../deploy/assets/images/spongeshadow_2.png", id:"spongeshadow_2"},
		{src:"../../../deploy/assets/images/SpongeTop.png", id:"SpongeTop"},
		{src:"../../../deploy/assets/images/SpongeTop_2.png", id:"SpongeTop_2"},
		{src:"../../../deploy/assets/images/Towel_001.png", id:"Towel_001"},
		{src:"../../../deploy/assets/images/Towel_002.png", id:"Towel_002"},
		{src:"../../../deploy/assets/images/Towel_003.png", id:"Towel_003"},
		{src:"../../../deploy/assets/images/Towel_004.png", id:"Towel_004"},
		{src:"../../../deploy/assets/images/Towel_005.png", id:"Towel_005"},
		{src:"../../../deploy/assets/images/Towel_007.png", id:"Towel_007"}
	],
	preloads: []
};



// bootstrap callback support:

(lib.Stage = function(canvas) {
	createjs.Stage.call(this, canvas);
}).prototype = p = new createjs.Stage();

p.setAutoPlay = function(autoPlay) {
	this.tickEnabled = autoPlay;
}
p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

an.bootcompsLoaded = an.bootcompsLoaded || [];
if(!an.bootstrapListeners) {
	an.bootstrapListeners=[];
}

an.bootstrapCallback=function(fnCallback) {
	an.bootstrapListeners.push(fnCallback);
	if(an.bootcompsLoaded.length > 0) {
		for(var i=0; i<an.bootcompsLoaded.length; ++i) {
			fnCallback(an.bootcompsLoaded[i]);
		}
	}
};

an.compositions = an.compositions || {};
an.compositions['34C4802D30D7425CB15EC705EC755935'] = {
	getStage: function() { return exportRoot.getStage(); },
	getLibrary: function() { return lib; },
	getSpriteSheet: function() { return ss; },
	getImages: function() { return img; }
};

an.compositionLoaded = function(id) {
	an.bootcompsLoaded.push(id);
	for(var j=0; j<an.bootstrapListeners.length; j++) {
		an.bootstrapListeners[j](id);
	}
}

an.getComposition = function(id) {
	return an.compositions[id];
}



})(lib_Stage = lib_Stage||{}, images = images||{}, createjs = createjs||{}, ss = ss||{}, AdobeAn = AdobeAn||{});
var lib_Stage, images, createjs, ss, AdobeAn;